import { object, boolean, string } from 'yup';

export const DASHBOARD_USER_LANGUAGE_VALUES = [
  'en',
  'ro',
  'pl',
  'bg',
  'uk',
] as const;

export const DASHBOARD_USER_LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'ro', label: 'Romanian' },
  { value: 'pl', label: 'Polish' },
  { value: 'bg', label: 'Bulgarian' },
  { value: 'uk', label: 'Ukrainian' },
] as const;

export const NEW_DASHBOARD_USER_SCHEMA = object().shape({
  first_name: string().required('Name is required'),
  last_name: string().required('Name is required'),
  email: string().required('Email is required').email(),
  status: string().required('Status is required'),
  is_chat_user: boolean(),
  test_account: boolean(),
  chat_translation_enabled: boolean(),
  language: string()
    .oneOf([...DASHBOARD_USER_LANGUAGE_VALUES])
    .required('Language is required'),
});

export const NEW_DASH_USER_DEFAULT_VALUES = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  profile_image: '',
  gender: '',
  is_chat_user: false,
  test_account: false,
  chat_translation_enabled: false,
  language: 'en',
  status: '',
  user_roles: [],
  job_title: '',
  short_description: '',
};
